import { __awaiter } from "tslib";
import AjaxUtils from './ajaxUtils';
const editContactData = (_a) => __awaiter(void 0, [_a], void 0, function* ({ contactId, jobTitle, emails, phones, emailsMetadata, phonesMetadata, company, metadata, }) {
    const route = '/v4/edit-contacts';
    const body = {
        contactId,
        jobTitle,
        emails,
        phones,
        emailsMetadata,
        phonesMetadata,
        company,
        metadata,
    };
    return AjaxUtils.post(route, body);
});
export { editContactData };
